var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.376,
    viewBox: "0 0 22 22.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7518 -16469.624)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: "2px",
    stroke: "currentColor",
    d: "M-7469,16603.473h22",
    transform: "translate(-49.001 -112.473)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0.75px",
    d: "M9.258-2.7a6.932,6.932,0,0,0,7.1-7.051V-20.7h-1.59V-9.751A5.394,5.394,0,0,1,9.258-4.238,5.4,5.4,0,0,1,3.72-9.751V-20.7H2.13V-9.751A6.938,6.938,0,0,0,9.258-2.7Z",
    transform: "translate(-7516.13 16490.699)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.7d00d49f.svg";
export { ForwardRef as ReactComponent };